// src/components/LandingHome.js
import React from "react";
import { Link } from "react-router-dom";
import "./LandingHome.css";

export default function LandingHome() {
  return (
    <div className="lp-root">
      {/* NAV */}
      <nav className="lp-nav">
        <div className="logo">OPERATION BORDER LIGHTS</div>

        <div className="lp-nav-right">
          <Link to="/command-center" className="btn ghost">
            Command Center
          </Link>
          <Link to="/login" className="btn glow">
            Enter Platform
          </Link>
        </div>
      </nav>

      {/* HERO */}
      <section className="lp-hero">
        <div className="hero-left">
          <span className="badge">REAL-TIME INTELLIGENCE PLATFORM</span>

          <h1>
            Border Awareness.<br />
            <span>Delivered in Real Time.</span>
          </h1>

          <p>
            Operation Border Lights is a centralized command platform that
            visualizes border activity, incidents, and reports in one unified
            operational view.
          </p>

          <div className="hero-actions">
            <Link to="/login" className="btn glow big">
              Enter Command Center
            </Link>
            <Link to="/registration" className="btn ghost big">
              Request Access
            </Link>
          </div>

          <div className="hero-kpis">
            <div className="kpi">
              <div className="kpi-num">Secure</div>
              <div className="kpi-label">Access Control</div>
            </div>
            <div className="kpi">
              <div className="kpi-num">Live</div>
              <div className="kpi-label">Operational View</div>
            </div>
            <div className="kpi">
              <div className="kpi-num">Unified</div>
              <div className="kpi-label">Reports + Signals</div>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-media">
            <img src="arrest.jpeg" alt="Border surveillance map" />
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <section className="lp-stats">
        <Stat n="Live" t="Map Intelligence" />
        <Stat n="Secure" t="Cloud Infrastructure" />
        <Stat n="Unified" t="Single Platform" />
        <Stat n="Operational" t="Mission Ready" />
      </section>

      {/* FEATURES */}
      <section className="lp-section">
        <div className="section-head">
          <h2>Built for Situational Awareness</h2>
          <p>
            Designed for fast recognition, clean reporting, and confident
            decision-making.
          </p>
        </div>

        <div className="feature-row">
          <img
            src="https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?auto=format&fit=crop&w=1400&q=80"
            alt="Operations room"
            loading="lazy"
          />
          <div className="feature-copy">
            <h3>Live Map Intelligence</h3>
            <p>
              Instantly visualize reports and activity on an interactive map
              designed for fast decision-making.
            </p>
          </div>
        </div>

        <div className="feature-row reverse">
          <img
            src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1400&q=80"
            alt="Data dashboard"
            loading="lazy"
          />
          <div className="feature-copy">
            <h3>Real-Time Reporting</h3>
            <p>
              Submit and track reports as events happen, with updates reflected
              instantly across the platform.
            </p>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="lp-section dark">
        <div className="section-head center">
          <h2>How It Works</h2>
          <p>From field reports to a clear operational picture in moments.</p>
        </div>

        <div className="steps">
          <Step n="01" t="Collect Reports" />
          <Step n="02" t="Visualize Activity" />
          <Step n="03" t="Respond with Confidence" />
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <h2>Take Control of the Operational Picture</h2>
        <p>
          When information is clear, decisions are faster. When decisions are
          faster, outcomes improve.
        </p>
        <div className="cta-actions">
          <Link to="/login" className="btn glow big">
            Access the Platform
          </Link>
          <Link to="/registration" className="btn ghost big">
            Request Access
          </Link>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="footer-grid">
          <div>
            <h4>Operation Border Lights</h4>
            <p>
              A real-time intelligence and visualization platform built for
              mission-critical environments.
            </p>
          </div>

          <div>
            <h5>Platform</h5>
            <a href="#">Capabilities</a>
            <a href="#">Security</a>
            <a href="#">Access</a>
          </div>

          <div>
            <h5>Access</h5>
            <Link to="/login">Login</Link>
            <Link to="/registration">Request Access</Link>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} Operation Border Lights. All rights
          reserved.
        </div>
      </footer>
    </div>
  );
}

/* helpers */
const Stat = ({ n, t }) => (
  <div className="stat">
    <h3>{n}</h3>
    <p>{t}</p>
  </div>
);

const Step = ({ n, t }) => (
  <div className="step-card">
    <span>{n}</span>
    <h4>{t}</h4>
  </div>
);
